import './FiAddSeoPageDialog.scss';
import { FiFurnitureService } from '../../components/fiFurniture/FiFurnitureService';

import * as angular from 'angular';

import { Component } from '../Component';

@Component({
    controllerAs: 'vm',
    template: require('./FiAddSeoPageDialog.html'),
    bindings: {
        infoTitle: '@',
        infoContent: '@',
        category: '@',
    },
})
export class FiAddSeoPageDialog {
    static $inject = [
        '$mdDialog',
        'fiFurnitureService',
        '$window',
        '$http',
        '$timeout',
    ];

    constructor(
        private $mdDialog: angular.material.IDialogService,
        private fs: FiFurnitureService,
        private $window: angular.IWindowService,
        private $http: angular.IHttpService,
        private $timeout: angular.ITimeoutService,
    ) {
        //
    }

    name: string;
    url: string;
    follow: boolean;
    loading: boolean = false;

    $onInit() {
        // console.log(this.fs.furniture)
    }

    close() {
        this.$mdDialog.cancel();
    }

    insert() {
        this.loading = true;
        this.$http.post("https://www.fitit.lt/db/add-seo-page.php", { 

            name: this.name,
            url: this.url,
            follow: this.follow,

        }, { headers: {'Content-Type': 'application/json'} })
        .then(function (response) {
            //
        });

        // this.$mdDialog.cancel();

         this.$timeout(() => {

            this.loading = false;
            location.reload();

        }, 2000);

    }

}